import { ACTIONS } from "../../enums/actions";
import { genericAction } from "./genericAction";

export const login = genericAction(ACTIONS.LOGIN)
export const logout = genericAction(ACTIONS.LOGOUT)
export const requestResetPassword = genericAction(ACTIONS.REQUEST_PASSWORD_RESET)
export const resetPassword = genericAction(ACTIONS.PASSWORD_RESET)
export const getUserRolesByUser = genericAction(ACTIONS.GET_USER_ROLES)
export const confirmEmail = genericAction(ACTIONS.CONFIRM_EMAIL)